import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getTipoStatusVaga, cadastrarTipoStatusVaga, alterarTipoStatusVaga, excluirTipoStatusVaga } from './tipos_status_vagas.service';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
export var TiposStatusVagasAlterar = function () {
    var services = {
        getItem: getTipoStatusVaga,
        cadastrarItem: cadastrarTipoStatusVaga,
        alterarItem: alterarTipoStatusVaga,
        excluirItem: excluirTipoStatusVaga,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.TIPOS_STATUS_VAGAS, paginaPermissao: FUNCIONALIDADES.TIPOS_STATUS_VAGAS, rota: ROUTES.TIPOS_STATUS_VAGAS, services: services });
};
export default TiposStatusVagasAlterar;
